<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.fa_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fa_date">
            <label class="weui-form-preview__label">{{
              customLabel.fa_date || "申请日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.fa_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_pleaseman" key="申请人">
            <label class="weui-form-preview__label">{{
              customLabel.fa_pleaseman || "申请人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.fa_department }} {{ form.main.fa_pleaseman }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fa_currency" key="币种">
            <label class="weui-form-preview__label">{{
              customLabel.fa_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.fa_currency }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fa_type" key="申请类型">
            <label class="weui-form-preview__label">{{
              customLabel.fa_type || "申请类型"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.fa_type }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fa_amount">
            <label class="weui-form-preview__label">{{
              customLabel.fa_amount || "申请金额(元)"
            }}</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.fa_amount
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_class">
            <label class="weui-form-preview__label">{{
              customLabel.fa_class || "费用类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_class
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_islimit">
            <label class="weui-form-preview__label">{{
              customLabel.fa_islimit || "参与额度管控"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_islimit ? "是" :"否"
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_fpcode">
            <label class="weui-form-preview__label">{{
              customLabel.fa_fpcode || "费用报销单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_fpcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_loancode">
            <label class="weui-form-preview__label">{{
              customLabel.fa_loancode || "借款申请单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_loancode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_sourcetype">
            <label class="weui-form-preview__label">{{
              customLabel.fa_sourcetype || "来源类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_sourcetype
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_sourcecode">
            <label class="weui-form-preview__label">{{
              customLabel.fa_sourcecode || "来源单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_sourcecode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fa_content">
            <label class="weui-form-preview__label">{{
              customLabel.fa_content || "费用内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fa_content
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.fa_text1 || '自定义字段1'"
          v-model="form.main.fa_text1" slot="fa_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.fa_text2 || '自定义字段2'"
          v-model="form.main.fa_text2" slot="fa_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.fa_text3 || '自定义字段3'"
          v-model="form.main.fa_text3" slot="fa_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.fa_text4 || '自定义字段4'"
          v-model="form.main.fa_text4" slot="fa_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.fa_text5 || '自定义字段5'"
          v-model="form.main.fa_text5" slot="fa_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.fad_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="fad_vendname">
              <label class="weui-form-preview__label">{{
                customLabel.fad_vendname || "供应商"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fad_vendname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fad_custname">
              <label class="weui-form-preview__label">{{
                customLabel.fad_custname || "客户"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fad_custname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fad_amount">
              <label class="weui-form-preview__label">{{
                customLabel.fad_amount || "金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.fad_amount,'#,##0.00')
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.fad_text1 || '自定义字段1'"
            v-model="item.fad_text1" slot="fad_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fad_text2 || '自定义字段2'"
            v-model="item.fad_text2" slot="fad_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fad_text3 || '自定义字段3'"
            v-model="item.fad_text3" slot="fad_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fad_text4 || '自定义字段4'"
            v-model="item.fad_text4" slot="fad_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.fad_text5 || '自定义字段5'"
            v-model="item.fad_text5" slot="fad_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <file-list v-model="form.main.fa_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/fee_apply_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        @click="turnFeePlease"
        v-if="!editable && !form.main.fa_fpcode"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >转报销</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/oa/feeapply",
      codeField: "fa_code",
      statusField: "fa_statuscode",
      caller: "FeeApply",
      xtype: "oa-feeapply-formpanel",
    };
  },
  methods: {
    turnFeePlease() {
      const me = this;
      me.$router.push({
        name: "OaFeeApplyTurnEdit",
        params: {
          id: me.form.main.id,
        }
      });
    }
  }
};
</script>